export enum SecondarySectionExpandableBlock {
  Root = 'SecondarySectionExpandable',
}
